
export default {
  data() {
    return {
      visible: false,
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.scrollListener)
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.scrollListener)
  },
  methods: {
    scrollListener: function (e) {
      this.visible = window.scrollY > 600
    },
  },
}
